import { useContext, useState } from 'react';
import moment from 'moment';
import {
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Switch,
  FormGroup,
  FormControlLabel,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { AuthContext, stopPropagationForTab } from 'components';
import { Tracking } from 'components/Tracking';
import { useNavigate } from "react-router-dom";


export const BulkModal = (props) => {
  const { items, onClose } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [ saving, setSaving ] = useState(false);
  const { updateItem } = useContext(AuthContext);

  const [ deliveryStart, setDeliveryStart ] = useState(items[0]?.deliveryStart ? moment(items[0]?.deliveryStart * 1000) : null)
  const [ deliveryEnd, setDeliveryEnd ] = useState(items[0]?.deliveryEndDate ? moment(items[0]?.deliveryEndDate * 1000) : null)
  const [ deliveryEndEnabled, setDeliveryEndEnabled ] = useState(false)

  const deliveryStartMinDate = moment().subtract(1, 'years').month(0)
  const deliveryStartMaxDate = deliveryEnd || moment().add(1, 'years').month(11)
  const deliveryEndMinDate = deliveryStart || moment().subtract(1, 'years').month(0)
  const deliveryEndMaxDate = moment().add(1, 'years').month(11)


  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/products_reload");
    onClose();
  }

  const handleSave = () => {
    Tracking.track('Portal - Bulk edit Delivery', { items: items.length })
    let bulk_update = []

    items.forEach((item) => {
      let values = {
        deliveryStart: deliveryStart.unix()
      }
      if (deliveryEndEnabled) {
        values.deliveryEndDate = deliveryEnd.unix()
      }

      bulk_update.push(new Promise((resolve, rejejct) => {
        updateItem(
          item,
          values,
          resolve
        )
      }))
    })

    Promise.all(bulk_update).then(() => {
      handleClose()
    })
  }

  
  return (
    <>
      <MenuItem onClick={handleOpen}>
        <div>Delivery</div>
      </MenuItem>
      <Dialog onKeyDown={stopPropagationForTab} open={open} onClose={handleClose}>
        <DialogTitle>Set Delivery</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Change delivery status of all of your selected items
          </DialogContentText>
          {/*  */}
          <Grid container spacing={1} sx={{ marginTop: 1 }}>
            <Grid item xs={6}></Grid>
            <Grid item>
              <FormGroup>
                <FormControlLabel 
                  control={
                    <Switch 
                      value={deliveryEndEnabled}
                      onChange={(e) => setDeliveryEndEnabled(e.target.checked)}
                    />
                  }
                  label="Set End Date" 
                  labelPlacement="start"
                />
              </FormGroup>
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ marginTop: 1 }}>
            <Grid item xs={6}>
              <DatePicker 
                views={['month', 'year']}
                value={deliveryStart}
                minDate={deliveryStartMinDate}
                maxDate={deliveryStartMaxDate}
                format="MMM YYYY"
                localeText={{
                  fieldMonthPlaceholder: () => "MMM"
                }}
                onChange={(newDate) => {
                  setDeliveryStart(moment(newDate).date(1).hour(0).minute(0).second(0))
                }}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                label={'Delivery Start'}
              />
            </Grid>
            <Grid item xs={6}>
              <DatePicker 
                views={['month', 'year']}
                value={deliveryEnd}
                minDate={deliveryEndMinDate}
                maxDate={deliveryEndMaxDate}
                disabled={!deliveryEndEnabled}
                format="MMM YYYY"
                localeText={{
                  fieldMonthPlaceholder: () => "MMM"
                }}
                onChange={(newDate) => {
                  setDeliveryEnd(moment(newDate).date(1).hour(0).minute(0).second(0).add(1, 'months').subtract(1, 'days'))
                }}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                label={'Delivery End (Optional)'}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={saving} onClick={() => { setSaving(true); setTimeout(handleSave, 200) }}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}